import { Phone } from "lucide-react";

export const TapToCall = () => (
  <a
    href="tel:705-433-2050"
    data-testid="tap-to-call-button"
    className="fixed bottom-6 left-4 z-50 md:hidden inline-flex items-center gap-2 rounded-full bg-white px-5 py-3.5 text-sm font-semibold text-[#060D1A] shadow-2xl shadow-black/40 transition-transform duration-300 active:scale-95"
  >
    <Phone className="h-4 w-4" />
    Call Owen
  </a>
);
